import { actionDuckUtils } from 'wanderu-ducks-utils';
import { getLogger } from 'wanderu-logger';
import { processNewParagraph } from 'wanderu-utils';

import getContent from '../../../data';
import {
    processCarriers,
} from '../../../utils';
import {
    setPageContent,
} from '../../appstate/actions';
import sliceNamespace from '../../types';

const namespace = 'FETCH_AIRPORT_SHUTTLES_GUIDE_PAGE';

const logger = getLogger('AirportShuttlesGuides');

const {
    actions,
    reducer,
    selectors,
} = actionDuckUtils.buildBaseDuck(namespace, sliceNamespace);

function loadLocalPageContent(locale, wid) {
    const rawContent = getContent();
    const content = rawContent?.[locale]?.[`${wid}content`];
    const factoids = rawContent?.[locale]?.[`${wid}factoids`];
    const images = rawContent?.[locale]?.[`${wid}images`];

    if (!content || !factoids || !images) {
        throw new Error('error loading local content, factoids, or images');
    }

    return [
        content,
        factoids,
        images,
    ];
}

const fetchPageContent = (wid, locale) => {
    return async (dispatch, getState) => {
        let error = null;
        let valuesList;

        const pageId = `${locale}-${wid}`;

        const working = selectors.selectWorking(getState(), pageId);
        const success = selectors.selectSuccess(getState(), pageId);
        const fetchError = selectors.selectError(getState(), pageId);

        if (!wid || !locale || working || success || fetchError) {
            return;
        }

        dispatch(actions.startWork(pageId));

        /* begin temporary hack because loading from S3 doesn't work in prod */
        try {
            valuesList = loadLocalPageContent(locale, wid);
        } catch (e) {
            logger.error('fetchShuttleGuide', e, {
                locale,
                wid,
            });
        }
        /* end temporary hack */

        if (valuesList) {
            const rawData = valuesList.reduce((dataMap, contentJson) => ({
                ...dataMap,
                ...contentJson.result,
            }), {});

            const data = {
                ...rawData,
                carriers: processCarriers(rawData.carriers),
                content: processNewParagraph(rawData.content),
            };

            dispatch(setPageContent({
                data,
                pageId,
            }));
        } else {
            error = {
                message: 'unable to load page content',
            };
        }

        dispatch(actions.endWork(pageId, undefined, error));
    };
};

const fetchShuttleGuideAction = {
    fetchPageContent,
    ...selectors,
    ...actions,
};

export {
    actions,
    fetchShuttleGuideAction,
};

const general = {
    [namespace]: reducer,
};

export default general;
